import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { CookiesService } from './cookies.service';
import { HomeService } from './home.service';

@Injectable()
export class AuthService {
  constructor(
    private homeService: HomeService,
    private http: Http,
    private router: Router,
    private cookies: CookiesService
  ) {
    //    console.log('In AuthService::ctor');
  }

  private isLoggedIn = false;

  private loginStatus = new BehaviorSubject(false);

  private baseurl = environment.apiBaseUrl;

  doLogin(jwt) {
    //
    // Send the provided JWT over to the /user/login endpoint to validate the JWT, extract the user id, and give the token
    // and user id to the login component.
    //
    return this.http.post(`${this.baseurl}/user/login`, { jwt }).map((res: Response) => {
      const jsonResponse = res.json();
      if (jsonResponse.status.toLowerCase() === 'success') {
        this.isLoggedIn = true;
      }
      return jsonResponse;
    });
  }

  async isLogin() {
    //
    // Ideally, we want to base whether or not the user is logged in off of the state that was saved when doLogin() was called
    // above. However, if a user refreshes their browser, that state in memory will be lost because this object will be
    // recreated from scratch. However, their user id and token will still be stored in the browser's local storage. If we
    // think that they aren't logged in based on the saved state AND a userId exists, make the call to the backend to ensure
    // it is a valid user id.
    //
    // TODO: We also need to send the token so it can be validated because it isn't too hard to drop a userId on the system
    // and gain access to everyone's information.
    //
    if (!this.isLoggedIn) {
      const userId = localStorage.getItem('userId');
      if (userId !== null) {
        //        console.log('About to wait for call to /user/auth');
        this.isLoggedIn = await this.http
          .post(`${this.baseurl}/user/auth`, { userId })
          .map((res: Response) => {
            const jsonResponse = res.json();
            //            console.log(`[AuthService::isLogin] returned: ${JSON.stringify(jsonResponse)}`);
            if (jsonResponse.status.toLowerCase() === 'success') {
              //              console.log('Verified that userId is valid');
              return true;
            }
            //              console.warn('User id was not known');
            return false;
          })
          .toPromise();
      }
    }
    return this.isLoggedIn;
    //    const userId = localStorage.getItem('userId');
    //    //console.log(`[AuthService::isLogin] calling back end with userId: ${userId}`);
    //    return this.http.post(this.baseurl + '/user/auth', { 'userId': userId }).
    //    map((res: Response) => { /*console.log(`[AuthService::isLogin] returned: ${JSON.stringify(res.json())}`);*/ return res.json() });
  }

  isAdmin() {
    const jwt = this.cookies.get('jwt') || this.getToken();
    if (!jwt) {
      // console.error('[AuthService::isAdmin()] No "jwt" cookie exists! Totally possible if user has been logged in and cookie is expired/gone. Everything based on token instead of jwt until now. If the jwt doesnt exist, should we use the token instead?');
      // console.log(`Found token: ${JSON.stringify(localStorage.getItem('token'))}`);
    }
    return this.http.post(`${this.baseurl}/user/roles`, { jwt }).map((res: Response) => {
      const { roles } = res.json();
      return roles.includes('ralFinancialSuiteAdmin');
    });
  }

  doLogout() {
    this.cleanupSettings();
    localStorage.removeItem('token');

    this.cookies.delete('jwt');

    this.isLoggedIn = false;
  }

  devLogin(payload) {
    //
    // Ask the back end for the development/admin user's information that we can package into a JWT before
    // redirecting to the root (which will then do the auth as if they were sent over by the RAL Academy site).
    //
    return this.http
      .post(`${this.baseurl}/dev/auth`, { payload })
      .map((res: Response) => res.json());
  }

  impersonateUser(newUser) {
    this.cleanupSettings();
    localStorage.setItem('userId', newUser);
  }

  cleanupSettings() {
    const data = { project_id: '', company_id: '' };
    this.homeService.updateProjectDetails(data).subscribe();
    //
    // The clearing of a user's selected company and project above can be done asynchronously. Regardless of whether or
    // not it succeeds, we need to remove all of these items from local storage.
    //
    localStorage.removeItem('select-page');
    localStorage.removeItem('projectId');
    localStorage.removeItem('companyLogo');
    localStorage.removeItem('select-page');
    localStorage.removeItem('otherFieldsArrayPayroll');
    localStorage.removeItem('otherFieldsArrayGeneral');
    localStorage.removeItem('otherFieldsArrayOpex');
    localStorage.removeItem('userId');
  }

  getToken(): string {
    return localStorage.getItem('token');
  }
}



// WEBPACK FOOTER //
// ./src/app/service/auth.service.ts